/* @flow */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { renderRoutes } from 'react-router-config';
import { compose } from 'redux';
import { css } from 'linaria';
import { segmentHelper, experimentDebugger } from '@marvelapp/react-ab-test';

import routes from './routes';
import ScrollToTop from './components/ScrollToTop';
import Segment from '../utilities/Segment';
import withCurrentUser from './components/withCurrentUser';

segmentHelper.enable();
experimentDebugger.enable();

class App extends Component<{ history: Object }> {
  componentDidMount() {
    const { history } = this.props;
    let track = Segment.page;
    track();
    history.listen(track);
  }

  render() {
    return (
      <div id="app">
        <ScrollToTop>{renderRoutes(routes)}</ScrollToTop>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withCurrentUser
)(App);

// eslint-disable-next-line no-unused-vars
const CircularBook = css`
  @font-face {
    font-family: Circular;
    font-weight: 400;
    font-style: normal;
    src: url(../../../assets/fonts/lineto-circular-book.eot) format('embedded-opentype'),
      url(../../../assets/fonts/lineto-circular-book.woff2) format('woff2'),
      url(../../../assets/fonts/lineto-circular-book.woff) format('woff');
  }
`;
// eslint-disable-next-line no-unused-vars
const CircularMedium = css`
  @font-face {
    font-family: Circular;
    font-weight: 500;
    font-style: normal;
    src: url(../../../assets/fonts/lineto-circular-medium.eot) format('embedded-opentype'),
      url(../../../assets/fonts/lineto-circular-medium.woff2) format('woff2'),
      url(../../../assets/fonts/lineto-circular-medium.woff) format('woff');
  }
`;
// eslint-disable-next-line no-unused-vars
const CircularBold = css`
  @font-face {
    font-family: Circular;
    font-weight: 700;
    font-style: normal;
    src: url(../../../assets/fonts/lineto-circular-bold.eot) format('embedded-opentype'),
      url(../../../assets/fonts/lineto-circular-bold.woff2) format('woff2'),
      url(../../../assets/fonts/lineto-circular-bold.woff) format('woff');
  }
`;
// eslint-disable-next-line no-unused-vars
const CircularBlack = css`
  @font-face {
    font-family: Circular;
    font-weight: 900;
    font-style: normal;
    src: url(../../../assets/fonts/lineto-circular-black.eot) format('embedded-opentype'),
      url(../../../assets/fonts/lineto-circular-black.woff2) format('woff2'),
      url(../../../assets/fonts/lineto-circular-black.woff) format('woff');
  }
`;



// WEBPACK FOOTER //
// ./src/ui/App.js